import {useRef, useMemo} from 'react';

function useMemoizedFn<T extends Func>(fn: T): ThisFunction<T> {
    const fnRef = useRef<T>(fn);
    fnRef.current = useMemo(() => fn, [fn]);

    const memoizedFn = useRef<ThisFunction<T>>();
    if (!memoizedFn.current) {
        memoizedFn.current = function (this, ...args) {
            return fnRef.current.apply(this, args);
        };
    }
    return memoizedFn.current;
}

export default useMemoizedFn;